<template>
    <form
        @change="isFormDirty"
        @submit.prevent="handleSubmit"
        :class="{ 'form-container': typeForm, 'form-modal-container': typeModal }"
        data-cy="form-container"
    >
        <p class="text-center text-default-red p-2" v-if="validation.message">
            {{ validation.message }}
        </p>
        <div class="form-section" data-cy="section-general">
            <div class="section-body">
                <div data-cy="field-category" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.list_manager_meta.form.labels.category') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.list_manager_meta.category.$error }"
                        v-model="v$.list_manager_meta.category.$model"
                        :disabled="record_type == 'existing'"
                    />
                    <div
                        data-cy="field-category-error"
                        :class="{ 'text-default-red': v$.list_manager_meta.category.$error }"
                        v-if="v$.list_manager_meta.category.required.$invalid && v$.list_manager_meta.category.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                    <validation-errors :errors="validation.errors.category" v-if="validation.errors" />
                </div>
                <div data-cy="field-list-name" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.list_manager_meta.form.labels.list_name') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.list_manager_meta.list_name.$error }"
                        v-model="v$.list_manager_meta.list_name.$model"
                    />
                    <div
                        data-cy="field-list-name-error"
                        :class="{ 'text-default-red': v$.list_manager_meta.list_name.$error }"
                        v-if="v$.list_manager_meta.list_name.required.$invalid && v$.list_manager_meta.list_name.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                    <validation-errors :errors="validation.errors.list_name" v-if="validation.errors" />
                </div>
                <div data-cy="field-list-description" class="input-container w-full px-4 mb-4">
                    <ui-label>{{ $t('admin.list_manager_meta.form.labels.list_description') }}</ui-label>
                    <ui-text-area
                        :class="{ 'form-error': v$.list_manager_meta.list_description.$error }"
                        v-model="v$.list_manager_meta.list_description.$model"
                    />
                    <validation-errors :errors="validation.errors.list_description" v-if="validation.errors" />
                </div>
                <div data-cy="field-item" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.list_manager_meta.form.labels.item') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.list_manager_meta.item.$error }"
                        v-model="v$.list_manager_meta.item.$model"
                    />
                    <validation-errors :errors="validation.errors.item" v-if="validation.errors" />
                </div>
                <div data-cy="field-value" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.list_manager_meta.form.labels.value') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.list_manager_meta.value.$error }"
                        v-model="v$.list_manager_meta.value.$model"
                    />
                    <validation-errors :errors="validation.errors.value" v-if="validation.errors" />
                </div>
                <div data-cy="field-description" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.list_manager_meta.form.labels.description') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.list_manager_meta.description.$error }"
                        v-model="v$.list_manager_meta.description.$model"
                    />
                    <validation-errors :errors="validation.errors.description" v-if="validation.errors" />
                </div>
                <div data-cy="field-option-a" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.list_manager_meta.form.labels.option_a') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.list_manager_meta.option_a.$error }"
                        v-model="v$.list_manager_meta.option_a.$model"
                    />
                    <validation-errors :errors="validation.errors.option_a" v-if="validation.errors" />
                </div>
                <div data-cy="field-option-b" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.list_manager_meta.form.labels.option_b') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.list_manager_meta.option_b.$error }"
                        v-model="v$.list_manager_meta.option_b.$model"
                    />
                    <validation-errors :errors="validation.errors.option_b" v-if="validation.errors" />
                </div>
                <div data-cy="field-option-c" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.list_manager_meta.form.labels.option_c') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.list_manager_meta.option_c.$error }"
                        v-model="v$.list_manager_meta.option_c.$model"
                    />
                    <validation-errors :errors="validation.errors.option_c" v-if="validation.errors" />
                </div>
                <div data-cy="field-flag-a" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.list_manager_meta.form.labels.flag_a') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.list_manager_meta.flag_a.$error }"
                        v-model="v$.list_manager_meta.flag_a.$model"
                    />
                    <validation-errors :errors="validation.errors.flag_a" v-if="validation.errors" />
                </div>
                <div data-cy="field-flag-b" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.list_manager_meta.form.labels.flag_b') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.list_manager_meta.flag_b.$error }"
                        v-model="v$.list_manager_meta.flag_b.$model"
                    />
                    <validation-errors :errors="validation.errors.flag_b" v-if="validation.errors" />
                </div>
                <div data-cy="field-flag-c" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.list_manager_meta.form.labels.flag_c') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.list_manager_meta.flag_c.$error }"
                        v-model="v$.list_manager_meta.flag_c.$model"
                    />
                    <validation-errors :errors="validation.errors.flag_c" v-if="validation.errors" />
                </div>
                <div data-cy="field-notes" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.list_manager_meta.form.labels.notes') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.list_manager_meta.notes.$error }"
                        v-model="v$.list_manager_meta.notes.$model"
                    />
                    <validation-errors :errors="validation.errors.notes" v-if="validation.errors" />
                </div>
            </div>
        </div>

        <div class="form-submit" v-if="form_type == 'form'">
            <ui-submit-button data-cy="submit-button" :disabled="processing">
                <span v-if="!processing">{{ $t('admin.list_manager_meta.form.buttons.save') }}</span>
                <span v-else>{{ $t('admin.list_manager_meta.form.buttons.saving') }}</span>
            </ui-submit-button>
        </div>

        <div class="drawer-footer" v-if="form_type == 'drawer'">
            <a-button data-cy="drawer-cancel-btn" class="btn-cancel" @click="onDrawerClose">
                {{ $t('admin.list_manager_meta.form.buttons.cancel') }}
            </a-button>
            <a-button data-cy="drawer-save-btn" class="ant-btn-primary" :disabled="processing" @click="handleSubmit">
                <span v-if="!processing">{{ $t('admin.list_manager_meta.form.buttons.save') }}</span>
                <span v-else>{{ $t('admin.list_manager_meta.form.buttons.saving') }}</span>
            </a-button>
        </div>
    </form>
</template>

<script>
import UiInput from '@/components/ui/Input.vue';
import UiLabel from '@/components/ui/Label.vue';
import UiSubmitButton from '@/components/ui/SubmitButton.vue';
import UiTextArea from '@/components/ui/TextArea.vue';

import ValidationErrors from '@/components/ui/ValidationErrors.vue';

import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        UiInput,
        UiTextArea,
        UiLabel,
        UiSubmitButton,
        ValidationErrors,
    },
    validations: {
        list_manager_meta: {
            category: {
                required,
            },
            list_name: {
                required,
            },
            list_description: {},
            item: {},
            value: {},
            description: {},
            flag_a: {},
            flag_b: {},
            flag_c: {},
            option_a: {},
            option_b: {},
            option_c: {},
            notes: {},
        },
    },
    computed: {
        typeForm() {
            return this.form_type !== 'modal';
        },
        typeModal() {
            return this.form_type == 'modal';
        },
    },
    props: {
        form_type: {
            type: String,
            default: 'drawer',
        },
        record_type: {
            type: String,
            default: 'new',
        },
        list_manager_meta: Object,
        processing: {
            type: Boolean,
            default: false,
        },
        validation: Object,
    },
    methods: {
        isFormDirty() {
            this.$emit('is-form-dirty', this.v$.$anyDirty);
        },
        async handleSubmit() {
            if (!(await this.v$.$validate())) return false;

            this.$emit('formSubmit', {
                type: this.record_type,
                data: this.list_manager_meta,
            });
        },
        onDrawerClose() {
            this.$emit('onDrawerClose');
        },
    },
};
</script>
